import axios from '../axios';

/**
 * 启用、关闭 代扣
 * @param {*} data
 * id	String	是	string
    isWithhold	是	string	是否代收扣款 1:否 0:是
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059645  20220519 
 */
export const enableFee = data => {
  return axios({
    url: '/schooltrainprice/update',
    method: 'post',
    data
  })
}
/**
 * 保存
 * @param {*} data 
 * district	是	string	行政区划 /驾校下拉中district
    districtName	是	string	行政区划名称 驾校下拉中districtName
    schoolName	是	string	驾校名称
    schoolId	是	string	驾校Id
    trainType	是	string	培训车型
    coursePrice	是	string	课程价格-单位分
    replacePrice	是	string	服务价格-单位分
    withholdPrice	是	string	代扣价格-单位分
    isWithhold	是	string	是否代收扣款 1:否 0:是
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059648  20220519
 */
export const save = data => {
  return axios({
    url: '/schooltrainprice/save',
    method: 'post',
    data
  })
}
/**
 * 根据驾校id查询 价格列表
 * @param {*} data 
 * schoolId	是	string	驾校Id
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059711  20220519  
 */
export const listBySchoolId = data => {
  return axios({
    url: '/schooltrainprice/queryBySchoolId',
    method: 'post',
    data
  })
}
/**
 * 分页查询 价格列表
 * @param {*} data 
 * district	否	string	行政区划
    schoolName	否	string	驾校名称
    trainType	否	string	培训车型
    type	否	string	1：科一科四 2 科二科三 3机器人 4模拟器
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059642  20220518
 */
export const page = data => {
  return axios({
    url: '/schooltrainprice/list',
    method: 'post',
    data,
  })
}


// WEBPACK FOOTER //
// ./src/http/modules/price.js